import React from 'react';
import { shallowEqual } from 'react-redux';
import { useFieldSelector } from '../../../../store/validation/validationStore';
import { FormContext, useFormContext } from '../FormContext';

export default function useFieldStatesClassNames(
  name: string,
  formName?: string,
): string {
  const formContext = React.useContext(FormContext);
  const innerFormName = formName ?? formContext.name;
  const { error, isTouched } = useFieldSelector(
    innerFormName,
    name,
    (props) => {
      return {
        error: props.error,
        isTouched: props.isTouched,
      };
    },
    shallowEqual,
  );
  const { avoidFieldsTouch } = useFormContext();
  if (error) return 'error';
  if (!avoidFieldsTouch && isTouched) return 'touched';
  return '';
}
